import React, { Component } from 'react'
import KYCUserListUI from './KYCUserListUI.js'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils.js'
import { withRouter } from 'react-router-dom'
import Modal from 'react-modal'


class KYCUserListSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      updateMode: false,
      updateDINMode: false,
      updatePhoneNumberMode: false,
      //Aadhaar Front upload
      fileUploadMode: false,
      fileUploadSuccessMsg: null,
      fileUploadErrorList: null,
      fileUploadSubmitted: false,
      //Aadhaar Back upload
      fileBackUploadMode: false,
      fileBackUploadSuccessMsg: null,
      fileBackUploadErrorList: null,
      fileBackUploadSubmitted: false,
      //
      selectedAadhaarUserId: null,
      // Fetch phone number loading state
      fetchingPhoneNumberUserId: null
    }
  }

  render() {
    return (
      <KYCUserListUI
        context={this.props.context}
        account={this.props.account}
        copyToClipboardText={this.props.copyToClipboardText}
        onCopyToClipboard={this.props.onCopyToClipboard}
        accountUserList={this.props.accountUserList}
        onRefreshClick={this.props.onRefreshClick}
        updateMode={this.state.updateMode}
        selectedUserId={this.state.selectedUserId}
        selectedAadhaarUserId={this.state.selectedAadhaarUserId}
        onUpdateClick={this.onUpdateClick}
        updateDINMode={this.state.updateDINMode}
        onDINUpdateClick={this.onDINUpdateClick}
        onUpdateAadhaarClick={this.onUpdateAadharLinkClick}
        onUpdateCancel={() => { this.setState({ updateMode: false }) }}
        onDINUpdateCancelClick={() => { this.setState({ updateDINMode: false }) }}
        updatePhoneNumberMode={this.state.updatePhoneNumberMode}
        onPhoneNumberUpdateClick={this.onPhoneNumberUpdateClick}
        onPhoneNumberUpdateCancelClick={() => { this.setState({ updatePhoneNumberMode: false }) }}
        onFetchPhoneNumberClick={this.onFetchPhoneNumberClick}
        fetchingPhoneNumberUserId={this.state.fetchingPhoneNumberUserId}
        //
        onCreateUserClick={this.props.onCreateUserClick}
        onCreateDirectorClick={this.props.onCreateDirectorClick}
        // Front upload
        fileUploadMode={this.state.fileUploadMode}
        fileUploadSubmitted={this.state.fileUploadSubmitted}
        fileUploadSuccessMsg={this.state.fileUploadSuccessMsg}
        fileUploadErrorList={this.state.fileUploadErrorList}
        onFileUploadClick={() => { this.setState({ fileUploadMode: true }) }}
        onfileUploadCancel={() => { this.setState({ fileUploadMode: false }) }}
        onfileUpload={this.onfileUpload}
        // Back upload
        fileBackUploadMode={this.state.fileBackUploadMode}
        fileBackUploadSubmitted={this.state.fileBackUploadSubmitted}
        fileBackUploadSuccessMsg={this.state.fileBackUploadSuccessMsg}
        fileBackUploadErrorList={this.state.fileBackUploadErrorList}
        onfileBackUploadClick={() => { this.setState({ fileBackUploadMode: true }) }}
        onfileBackUploadCancel={() => { this.setState({ fileBackUploadMode: false }) }}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')
  }

  onUpdateClick = (event) => {
    let userId = event.currentTarget.getAttribute('data-user-id')
    this.setState({ updateMode: true, selectedUserId: userId })
  }
  onDINUpdateClick = (event) => {
    let userId = event.currentTarget.getAttribute('data-user-id')
    console.log('onDINUpdateClick : ', userId)
    this.setState({ updateDINMode: true, selectedUserId: userId })
  }

  onPhoneNumberUpdateClick = (event) => {
    let userId = event.currentTarget.getAttribute('data-user-id')
    console.log('onPhoneNumberUpdateClick : ', userId)
    this.setState({ updatePhoneNumberMode: true, selectedUserId: userId })
  }

  onFetchPhoneNumberClick = (userId) => {
    console.log('onFetchPhoneNumberClick : ', userId)
    
    // Set loading state
    this.setState({ fetchingPhoneNumberUserId: userId })
    
    RestApiUtils.patch(this.props.context,
      `/api/su/accounts/${this.props.account.accountId}/user/${userId}/phoneNumber/surepass`,
      this.onFetchPhoneNumberCallback,
      {}
    )
  }

  onFetchPhoneNumberCallback = (response) => {    
    // Clear loading state
    this.setState({ fetchingPhoneNumberUserId: null })
    
    if (response && response.errorList && response.errorList.length > 0) {
      // Handle error
      alert('Failed to fetch phone number: ' + response.errorList[0].message)
    } else if (response && response.success) {
      // Handle success
      alert('Phone number fetched successfully')
      // Refresh the data to show the updated phone number
      this.props.onRefreshClick('noBusy')
    } else {
      // Handle unexpected response
      alert('Unexpected response from server')
    }
  }

  onUpdateAadharLinkClick = (event) => {
    let userId = event.currentTarget.getAttribute('data-aadhaar-user-id')
    this.setState({ fileUploadMode: true, selectedAadhaarUserId: userId })
  }

  onfileUpload = (fileId, fileName, fileType, fileSize) => {
    console.log('onfileUpload : ', fileId, fileName, fileType, fileSize)

    let frontOrBack = fileId.includes('front') ? 'front' : 'back'
    if (frontOrBack === 'front') {
      this.setState({
        fileUploadSubmitted: true,
        fileUploadSuccessMsg: null,
        fileUploadErrorList: []
      })
    } else {
      this.setState({
        fileBackUploadSubmitted: true,
        fileBackUploadSuccessMsg: null,
        fileBackUploadErrorList: []
      })
    }

    !this.state.fileBackUploadSubmitted && this.setState({
      fileBackUploadMode: true,
    })

    !this.state.fileUploadSubmitted && this.setState({
      fileUploadMode: true,
    })

    console.log(this.state.fileUploadSubmitted, this.state.fileBackUploadSubmitted)
    if (this.state.fileUploadSubmitted && this.state.fileBackUploadSubmitted) {
      RestApiUtils.post(this.props.context,
        `/api/su/accounts/${this.props.match.params.accountId}/users/${this.state.selectedAadhaarUserId}/aadhaar/validation`,
        this.onfileUploadCallback, {
        fileUpload: {
          fileId: fileId,
          fileName: fileName,
          fileType: fileType,
          fileSize: fileSize
        }
      }
      )
    }
  }

  onfileUploadCallback = (response) => {
    this.setState({ fileUploadSubmitted: false, fileBackUploadSubmitted: false })
    console.log('fileUploaded: ' + this.state.fileUploadSubmitted)
    console.log('fileBackUploaded: ' + this.state.fileBackUploadSubmitted)
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      fileUploadSuccessMsg: response.success,
      fileUploadErrorList: errorList,
      fileBackUploadSuccessMsg: response.success,
      fileBackUploadErrorList: errorList
    })

    this.props.onRefreshClick('noBusy')

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          fileUploadSuccessMsg: null,
          fileBackUploadSuccessMsg: null
        })
      }, 2000)
    }
  }
}
export default withRouter(KYCUserListSF)
